import React from 'react'
import { Box, SxProps } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { Variant } from '@mui/material/styles/createTypography'
import { Typography } from '../Typography'

interface StyleProps {
  titleTop?: boolean
  icon: React.ReactNode
  iconPosition: 'left' | 'right'
}

const useStyles = makeStyles<StyleProps>()((theme, props) => ({
  textWrapper: {
    display: 'flex',
    flexDirection: props.titleTop ? 'column' : 'column-reverse',
    justifyContent: 'center',
    alignItems: 'flex-start',
    marginLeft: props.icon && props.iconPosition === 'left' ? theme.spacing(1) : 0,
    marginRight: props.icon && props.iconPosition === 'right' ? theme.spacing(1) : 0,
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
  },
}))

export interface InfoTextProps {
  title?: string
  value?: string | number | React.ReactElement
  titleTop?: boolean
  icon?: React.ReactNode
  className?: string
  textClassName?: string
  titleVariant?: Variant
  valueVariant?: Variant
  iconPosition?: 'left' | 'right'
  sx?: SxProps
}

const InfoText: React.FC<InfoTextProps> = ({
  title,
  value,
  titleTop,
  icon,
  titleVariant,
  valueVariant,
  className,
  textClassName,
  iconPosition = 'left',
  sx,
}) => {
  const { classes, cx } = useStyles({ titleTop, icon, iconPosition })

  return (
    <Box className={cx(classes.wrapper, className)} sx={sx}>
      {iconPosition === 'left' && icon}
      <Box className={cx(classes.textWrapper, textClassName)}>
        {title && <Typography variant={titleVariant ?? 'subtitle1'}>{title}</Typography>}
        {typeof value === 'string' || typeof value === 'number' ? (
          <Typography variant={valueVariant ?? 'subtitle2'}>{value.toString()}</Typography>
        ) : (
          value
        )}
      </Box>
      {iconPosition === 'right' && icon}
    </Box>
  )
}

export default InfoText
